module.exports = __webpack_public_path__ + "static/media/MItheater3.9974d5a5.jpg";